import LoadingButton from "@mui/lab/LoadingButton";
import { Box, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import AlertContext from "../../context/alert/alertContext";
import { useHistory } from "react-router-dom";
import TripContext from "../../context/trip/tripContext";
import SpotReviewComposerModal from "../spots/SpotReviewComposer/SpotReviewComposerModal";
import SpotReviewContext from "../../context/spot/spotReviewContext";
import DraftSpotReviews from "./DraftSpotReviews";
import ExistingReviewPickerModal from "./ExistingReviewPickerModal";

const AddTripComposer = ({ mode = "public" }) => {
    const isPlan = mode === "draft";
    const [isCreating, setIsCreating] = useState(false);
    const [, setIsTitleMissing] = useState(false);
    const history = useHistory();

    const tripContext = useContext(TripContext);
    const {
        addTrip,
        addTripComplete,
        tripAdded,
    } = tripContext;

    const spotContext = useContext(SpotReviewContext);
    const {
        draftSpotReviews,
    } = spotContext;

    const alertContext = useContext(AlertContext);
    const { setAlert } = alertContext;

    useEffect(() => {
        if (isCreating && tripAdded) {
            setIsCreating(false);
            setAlert(isPlan ? "Trip plan saved" : "Trip created", "success");
            addTripComplete();
            history.push(isPlan ? "/my-journeys" : "/destinations");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCreating, tripAdded, addTripComplete]);

    const handleSubmit = () => {
        if (trip.title === "") {
            setIsTitleMissing(true);
            setAlert("Please write a title", "error");
            return;
        }
        setIsCreating(true);
        trip.spotReviews = draftSpotReviews;
        trip.visibility = isPlan ? "draft" : "public";
        addTrip(trip);
    };

    const [trip, setTrip] = useState({
        title: "",
        content: "",
        spotReviewIDs: "",
        spotReviews: "",
    });

    return (
        <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3, maxWidth: 680 }}>
            <TextField
                fullWidth
                id="trip-title"
                label="Name your trip"
                name="title"
                variant="outlined"
                onChange={(e) => {
                    setTrip({
                        ...trip,
                        [e.target.name]: e.target.value,
                    });
                }}
                value={trip.title ?? ""}
                required
            />
            <DraftSpotReviews draftSpotReviews={draftSpotReviews}/>
            <Box sx={{ position: 'relative', width: '100%' }}>
                <SpotReviewComposerModal id={1} isDraft={true} allowFutureDates={isPlan}/>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, 24px)',
                        display: 'flex',
                        justifyContent: 'center',
                        pointerEvents: 'none',
                        '& > *': { pointerEvents: 'auto' },
                    }}
                >
                    <ExistingReviewPickerModal />
                </Box>
            </Box>
            <LoadingButton
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                loading={isCreating}
                sx={{ alignSelf: 'flex-start', borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 4 }}
            >
                {isPlan ? 'Save Plan' : 'Create & Publish'}
            </LoadingButton>
        </Box>
    );
}

export default AddTripComposer;
